import ProfilePanel from '../components/Profile/ProfilePanel';
import Headbar from '../components/Headbar';

export default function Profile() {
  return (
    <>
      <Headbar />
      <ProfilePanel />
    </>
  );
}
